import CompactSearch from './CompactSearch.js';
export { default } from './CompactSearch.js';
//# sourceMappingURL=index.js.map
